import React from 'react'
import './student-onboarding-task-card-2023.css'
import { MdWarningAmber } from 'react-icons/md';
import { createEllipses } from '../../utilityFunctions';
import { format, isValid } from 'date-fns';
import {
    getAssignedTeachersForCard,
    resolveTeacherImageUrl,
} from '../teacherAssignmentUtils';
import { isUntouchedStudentOnboardingCard } from '../studentOnboardingCardStatus';
import { formatDuplicateInquiryWarning } from '../duplicateInquiryUtils';

const StudentOnboardingTaskCard2023 = ({
    card,
    setStudentOnboardingModal,
    labels,
    showSchoolsOnCards,
    setToolTip,
    teachers = [],
    duplicateInquiryInfo = null,
}) => {
    const showSchoolChip = showSchoolsOnCards || card.whichList === 'teacher'
    const dueDate = new Date(card.todoDueDate)
    const hasValidDueDate = isValid(dueDate)
    const showTeacherStartDate = card.whichList === 'teacher' && hasValidDueDate
    const assignedTeachers = getAssignedTeachersForCard(card, teachers)
    const showNewCardIndicator = isUntouchedStudentOnboardingCard(card)
    const duplicateInquiryWarning = duplicateInquiryInfo
        ? formatDuplicateInquiryWarning(duplicateInquiryInfo)
        : ''

    const getTeacherInitials = (teacherName) => String(teacherName || 'Teacher')
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((namePart) => namePart[0])
        .join('')
        .toUpperCase()

    const calculateDaysSincePutOnWaitlist = (card) => {
        const today = new Date();
        if(card.whichList === 'waitlist' && card.waitlistEntity) {
            const daysSince = Math.floor((today - new Date(card.waitlistEntity.startDate)) / (1000 * 60 * 60 * 24));
            return <div className='days-on-waitlist__badge'>{daysSince} Days</div>
        } else if(card.whichList === 'inquiry') {
            if(Math.floor((today - new Date(card.todoDueDate)) / (1000 * 60 * 60 * 24)) > 2) {
                return <div className='days-on-waitlist__badge'>{Math.floor((today - new Date(card.todoDueDate)) / (1000 * 60 * 60 * 24))} Days</div>
            }
        }
    }

    const colorTheStripe = (card) => {
        if (card.whichList === 'orange' || card.todoDescription === 'Reassign') {
            return {backgroundColor: '#ffc579'}
        } else if (card.whichList === 'blue' || card.todoDescription === 'Old Student') {
            return {backgroundColor: '#81b8ff'}
        } else {
            return {backgroundColor: '#fff'}
        }
    }

    return(
        <div
            className={`student-onboarding-task-card-2023 ${showNewCardIndicator ? 'student-onboarding-task-card-2023--new' : ''}`}
            id={card.todoId}
            title={showNewCardIndicator ? 'New card — no tasks completed' : undefined}
            onMouseEnter={() => setToolTip(card)}
            onMouseLeave={() => setToolTip(false)}
            onClick={() =>setStudentOnboardingModal(card)}
        >
            <div className='student-onboarding-task-card-2023__stripe' style={colorTheStripe(card)}></div>
            <div className='student-onboarding-task-card-2023__user-wrapper'>
                <div className='student-onboarding-task-card-2023__user' id={`user-${card.todoId}`}>{labels[card.todoId] && labels[card.todoId].split(' ')[0]}</div>
            </div>
            <div className='student-onboarding-task-card-2023__info-wrapper'>
                <div className='student-onboarding-task-card-2023__title'>{createEllipses(card.todoName, 10)}</div>
                <div className='student-onboarding-task-card-2023__chip-wrapper'>
                    {duplicateInquiryWarning && (
                        <span
                            className='student-onboarding-task-card-2023__duplicate-warning'
                            aria-label={duplicateInquiryWarning}
                            title={duplicateInquiryWarning}
                        >
                            <MdWarningAmber size={13} aria-hidden='true' />
                            Duplicate email
                        </span>
                    )}
                    {card.whichList === 'intro' && hasValidDueDate && <div className='student-onboarding-task-card-2023__school' style={(dueDate > new Date() ) ? {backgroundColor: '#F1F5F9'} : {backgroundColor: '#FFEDD5'}} >{format(dueDate, 'MM/dd')}</div>}
                    {showTeacherStartDate && <div className='student-onboarding-task-card-2023__school' style={(dueDate > new Date() ) ? {backgroundColor: '#F1F5F9'} : {backgroundColor: '#FFEDD5'}} >{format(dueDate, 'MM/dd')}</div>}
                    {showSchoolChip && card.whichSchool && <div className='student-onboarding-task-card-2023__school'>{card.whichSchool.toUpperCase()}</div>}
                    {calculateDaysSincePutOnWaitlist(card)}
                    {card.summerBreak && <div className='student-onboarding-task-card-2023__summer-break'>☀️</div>}
                    {card.needsNewTeacher && <div className='student-onboarding-task-card-2023__needs-new-teacher'>👩‍🏫</div>}
                    {card.leavingDate && <div className='student-onboarding-task-card-2023__leaving-date'>{format(new Date(card.leavingDate), 'MM/dd')}</div>}
                    {card.leavingTeacherImage && <img className='student-onboarding-task-card-2023__teacher-image' src={card.leavingTeacherImage} alt='teacher'/>}
                    {assignedTeachers.length > 0 && (
                        <div className='student-onboarding-task-card-2023__teacher-faces'>
                            {assignedTeachers.map((teacher) => {
                                const teacherName = teacher.teacherName || 'Assigned teacher'
                                const imageUrl = resolveTeacherImageUrl(teacher.imageName)

                                return imageUrl ? (
                                    <img
                                        className='student-onboarding-task-card-2023__teacher-image'
                                        key={teacher.teacherId}
                                        src={imageUrl}
                                        alt={teacherName}
                                        title={teacherName}
                                    />
                                ) : (
                                    <span
                                        className='student-onboarding-task-card-2023__teacher-initials'
                                        key={teacher.teacherId}
                                        title={teacherName}
                                    >
                                        {getTeacherInitials(teacherName)}
                                    </span>
                                )
                            })}
                        </div>
                    )}
                </div>
                {/* {(card.whichList === 'orange' || card.todoDescription === 'Reassign') && <div className='student-onboarding-task-card-2023__status-badge'>Reassign</div>}
                {(card.whichList === 'blue' || card.todoDescription === 'Old Student') && <div className='student-onboarding-task-card-2023__status-badge old-student'>Old Student</div>} */}
                {(card.todoDescription === '4 free' || card.todoDescription === '3 free' || card.todoDescription === '2 free' || card.todoDescription === '1 free') && <div className='student-onboarding-task-card-2023__status-badge ad-offer'>{card.todoDescription.toUpperCase()}</div>}
            </div>
            {/* {card.hasIntroHappened && <div style={card.hasIntroHappened === 'called' ? {backgroundColor: 'green'} : {backgroundColor: '#F59E0B'}} className='student-onboarding-task-card-2023__intro-lesson-dot'></div>} */}
        </div>
    )
}
export default StudentOnboardingTaskCard2023
